function updateProgressBar() {
  var progressBar = document.getElementById('progress-bar');
  var progressIndicator = document.querySelector('.wpforms-page-indicator.progress');
  var totalStepsSpan = document.getElementById('total-steps');
  var currentStepSpan = document.getElementById('current-step');

  // Get the aria attributes
  var maxValue = parseInt(progressIndicator.getAttribute('aria-valuemax'));
  var currentValue = parseInt(progressIndicator.getAttribute('aria-valuenow'));

  // Calculate the percentage progress
  var percentage = (currentValue / maxValue) * 100;

  // Update the width of the progress bar with transition effect
  progressBar.style.transition = 'width 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)'; // Set transition effect
  progressBar.style.width = percentage + '%';

  // Update total steps elsewhere in HTML
  totalStepsSpan.textContent = maxValue;

  // Update current step without animation
  currentStepSpan.textContent = currentValue;
}

// Call the function initially
updateProgressBar();

// Create a MutationObserver to observe changes in the progress indicator
var observer = new MutationObserver(function(mutationsList) {
  for(var mutation of mutationsList) {
    if (mutation.type === 'attributes') {
      // If attributes of the progress indicator change, update the progress bar and values elsewhere
      updateProgressBar();
    }
  }
});

// Start observing the progress indicator for attribute changes
observer.observe(document.querySelector('.wpforms-page-indicator.progress'), { attributes: true });


// Listen for radio button select

document.addEventListener("DOMContentLoaded", function() {
  const allRadioButtons = document.querySelectorAll('input[type="radio"]');

  allRadioButtons.forEach(function(radioButton) {
    const parentLi = radioButton.closest("li");
    
    if (parentLi) {
      parentLi.addEventListener("click", function() {
        radioButton.click();
      });
    }
  });
});


// Listen for checkbox select

document.addEventListener("DOMContentLoaded", function() {
  const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');

  allCheckboxes.forEach(function(checkbox) {
    const parentLi = checkbox.closest("li");
    
    if (parentLi) {
      parentLi.addEventListener("click", function() {
        checkbox.click();
      });
    }
  });
});


// Get all required input fields
var requiredFields = document.querySelectorAll('.wpforms-field-required');

// Loop through each required field
requiredFields.forEach(function(field) {
  // Get the current placeholder text
  var placeholderText = field.getAttribute('placeholder');
  // Append an asterisk to the placeholder text
  field.setAttribute('placeholder', placeholderText + ' *');
});
